import { create } from "zustand";

type CPMallowedStore = {
  cpmAllowed: boolean;
  setCPMallowed: (arg: boolean) => void;
};

export const useCPMallowedStore = create<CPMallowedStore>((set) => ({
  cpmAllowed: true,
  setCPMallowed: (arg) => set({ cpmAllowed: arg }),
}));
